import { DialogActions, DialogTitle } from "@material-ui/core";
import React from "react";
import IAPI from "../../../../models/IAPI";
import IIntegration from "../../../../models/IIntegration";
import { RawLinkButton } from "../../../LinkButton";
import { submitAPIsUpdateServiceCall } from "../../functions/sharedFunctions";
import { SelectAPIsDialogContent } from "./SelectAPIsProdDialogContent";

interface ISelectAPIsProdDialogProps {
  token: string;
  username: string;
  integration: IIntegration;
  currentAPIs: IAPI[];
  closeDialog: () => void;
}

export const SelectAPIsProdDialog = (props: ISelectAPIsProdDialogProps) => {
  const { token, username, integration, currentAPIs, closeDialog } = props;
  const [apiSCNumber, setAPISCNumber] = React.useState<string>("");
  const [apiUpdateSubmitErrors, setAPIUpdateSubmitErrors] = React.useState<string[]>([]);
  const [selectedAPIs, setSelectedAPIs] = React.useState<IAPI[]>(currentAPIs);

  const hasAPISCNumber = (): boolean => {
    return apiSCNumber !== undefined && apiSCNumber !== "";
  };

  const handleSelectAPIsSubmit = async () => {
    await submitAPIsUpdateServiceCall(token, username, integration, selectedAPIs, currentAPIs, "API Update Request", setAPIUpdateSubmitErrors, setAPISCNumber);
  };

  return (
    <>
      {!hasAPISCNumber() && <DialogTitle id="alert-dialog-title">{`Select APIs for ${integration.Name}`}</DialogTitle>}
      {hasAPISCNumber() && <DialogTitle id="alert-dialog-title">{`API Review Ticket Submitted Successfully`}</DialogTitle>}
      <SelectAPIsDialogContent
        token={token}
        integration={integration}
        apiSCNumber={apiSCNumber}
        apiUpdateSubmitErrors={apiUpdateSubmitErrors}
        selectedAPIs={selectedAPIs}
        setSelectedAPIs={setSelectedAPIs}
      />
      <DialogActions>
        {!hasAPISCNumber() && (
          <RawLinkButton onClick={handleSelectAPIsSubmit} color="secondary">
            Confirm
          </RawLinkButton>
        )}
        <RawLinkButton onClick={closeDialog} color="primary">
          {hasAPISCNumber() ? "Close" : "Cancel"}
        </RawLinkButton>
      </DialogActions>
    </>
  );
};
